// tslint:disable:jsx-no-lambda
// tslint:disable:jsx-no-bind
// tslint:disable:jsx-no-string-ref
import * as React from 'react';
import { inject } from 'mobx-react';
import 'cropperjs/dist/cropper.css';
import { WithAriticleEdit } from '../../components/HOC/EditArticleHOC/EditArticleHOC';
import { WithMediaUpload } from '../../components/HOC/AliyunMediaUpload';
import { WithBaiduMediaUpload } from '../../components/HOC/BaiduMediaUpload';
import ArticleEdit from '../../components/ArticleEdit';
import { Button } from 'antd';
import * as classnames from 'classnames';
import moment from 'moment';
import tool from '@util/tool';

import './index.scss';
// @WithMediaUpload(inject('store'))
@WithBaiduMediaUpload(inject('store'))
@WithAriticleEdit(inject('store'))
export default class UpdateArticleMain extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            hasScrollBottom: false,
            previewActive: 0,
            userName: null,
        };
    }
    // 添加延迟事件监听，为了让图片加描述的内容及时响应上
    public addTimeoutEvent = (fn) => {
        setTimeout(() => {
            fn();
        }, 150);
    }
    public showPreview = () => {
        this.addTimeoutEvent(this.props.showPreview);
    }
    public showTimeing = () => {
        this.props.showTimeing();
    }
    public checkCreateArticel = () => {
        this.addTimeoutEvent(this.props.checkCreateArticel);
    }
    public closeCrop = (e) => {
        this.props.closeCrop(e);
    }
    /**
     * previewSwitch
     */
    public previewSwitch = (num) => {
        this.setState({
            previewActive: num,
        });
    }
    public componentWillMount() {
        sessionStorage.removeItem('DRAFTID');
        const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
        this.setState({
            userName: userInfo.nickname,
            avatar: userInfo.avatar,
        });
    }
    public componentDidMount() {
        console.log(this.props);

        window.onscroll = () => {
            if (tool.getScrollTop() + tool.getWindowHeight() > tool.getScrollHeight() - 80) {
                if (this.state.hasScrollBottom) {
                    this.setState({
                        hasScrollBottom: false,
                    });
                }
            } else {
                if (!this.state.hasScrollBottom) {
                    this.setState({
                        hasScrollBottom: true,
                    });
                }
            }
        };
    }
    public render() {
        console.log(this.props);
        const {articleQrcode, errorStatus, errorContent, previewBoxHasHide, cropImg, articleTitle, previewContent, getChildRefs } = this.props;
        const { hasScrollBottom, previewActive, userName, avatar } = this.state;
        return (
            <div className="UpdateArticleMainBox">
                <div className="createArticleHeader">
                    <div className="headerBox">
                        <div className="createArticleLogoNav">
                            <div className="createArticleLogo">
                                <a href="/"><img src={require('../../assets/images/commonImg/logoWhiteBg.png')} alt="" /></a>
                            </div>
                            <div className="createArticleNav">
                                <p><span>修改文章</span> > <span>编辑中</span></p>
                            </div>
                        </div>
                       {/*  <div className="createCheckBtn">
                            <div className="createCurrentBtn">
                                <span onClick={() => this.showPreview()}>预览手机版</span>
                            </div>
                            <div className="createArticleBtn">
                                <span onClick={() => this.checkCreateArticel()}>发布文章</span>
                            </div>
                        </div> */}
                    </div>
                </div>
                <ArticleEdit type="update" {...this.props} />
                <div className="button-box">
                    <div className={classnames('to-bottom-box', { fixed: hasScrollBottom })}>
                        <Button type="primary" onClick={() => this.showPreview()}>预览手机版</Button>
                        <Button type="primary" onClick={() => this.checkCreateArticel()}>发布文章</Button>
                    </div>
                </div>
                <div className={classnames('previewBox', { hide: previewBoxHasHide })}>
                    <div className="preview-content-box">
                        <div className="preview-nav">
                            {
                                ['普通预览', '扫码预览'].map((item, idx) => {
                                    return <span onClick={() => this.previewSwitch(idx)} className={idx === previewActive ? 'active' : null} key={idx}>{item}</span>;
                                })
                            }
                        </div>
                        <span className="previewCloseBtn" onClick={(e) => this.closeCrop(e)}>
                            <img src={require('../../assets/images/commonImg/whiteCloseBtn.png')} alt="" />
                        </span>
                        <div hidden={previewActive !== 0} className="phoneBox">
                            <div className="phoneBang"></div>
                            <div className="phoneConBox">
                                <div className="phoneBanner">
                                    <img src={cropImg} alt="" />
                                </div>
                                <div className="articleBox">
                                    <h3 className="phoneTitle">{articleTitle}</h3>
                                    <div className="articleTop">
                                        <div className="leftUserInfo">
                                            <div className="authorImg">
                                                {avatar && <img src={avatar} alt={userName} />}
                                            </div>
                                            <div className="nameTime">
                                                <div className="authorName">{userName || '未知'}</div>
                                                <div className="phonePublicTime">
                                                    {moment().format('MM月DD日')}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="rightFollow">
                                            <span>+关注</span>
                                        </div> */}
                                    </div>
                                    <div className="phoneArticleIco"></div>
                                    <div className="phoneArticleCon" dangerouslySetInnerHTML={{ __html: previewContent }}></div>
                                </div>

                                {/* <iframe style={{ width: '100%', height: '100%' }} id="dealIframe" name="dealIframe" width="100%" src={`${this.iframeAddr}/app/club/article/${sessionStorage.getItem('DRAFTID')}.html`} frameBorder="no" scrolling="yes"></iframe> */}
                            </div>
                            <div className="phoneMenu"></div>
                        </div>
                        <div className="qrcode-box" hidden={previewActive !== 1}>
                            <img src={articleQrcode} alt=""/>
                        </div>
                    </div>
                    <div className="previewBoxScreen" onClick={(e) => this.closeCrop(e)}></div>
                </div>
                <div className={classnames('bigScreen', { hide: errorStatus })}>
                    <div className="errInfo">{errorContent}</div>
                </div>
                <div className="itemEditorCon" ref={(itemEditorCon) => getChildRefs({ name: 'itemEditorCon', value: itemEditorCon })}></div>
            </div>
        );
    }
}
